export default __webpack_public_path__ + "static/media/section3-pic8.72e6ae26.png";